import React from 'react';
import { useTranslation } from 'react-i18next';

const CarpoolingInfo = ({ driver = {}, rental = {} }) => {
  const { t } = useTranslation(['booking']);

  const renderDriver = () => {
    return (
      <div className="section">
        <div className="title">{t('booking:driver-carpooling')}</div>
        <div className="section-content">
          {driver.first_name} {driver.last_name}
        </div>
      </div>
    );
  };

  return <div>{driver && <div>{renderDriver()}</div>}</div>;
};

export default CarpoolingInfo;
